import { memo } from "react"
import Button from "./Button/Index"
import Section from "./Section"
import FormService from "../services/formService"
import { useEffect, useState } from "react"
import { BUTTON_TEXT, DEFAULT_FORM_SETTINGS, ERROR } from "./consts.jsx"
import SecondaryTitle from "./Section/SecondaryTitle"
import FormTextInput from "./FormTextInput"
import Paste from "./Paste"
import { ClipBoardSingle } from "./svgs/SVGS"
import InfoBox from "./Toaster/InfoBox"
import BotzappingForm from "./BotzappingForm.jsx"

const InstallTag = ({ initSettings, cheqEssential }) => {
  const formService = new FormService()
  const secondaryTitleText = "CHEQ Essentials tag"
  const [loading, setLoading] = useState(false)
  const [buttonText, setButtonText] = useState(BUTTON_TEXT.ACTIVATE)
  const [errorMessage, setErrorMessage] = useState()
  const [secondaryButtonText, setSecondaryButtonText] = useState(null)
  const [settings, setSettings] = useState(DEFAULT_FORM_SETTINGS)

  const PasteElement = memo(({ onClick }) => (
    <Paste onClick={onClick} icon={<ClipBoardSingle />} text="Paste" />
  ))

  const setActivated = () => {
    setButtonText(BUTTON_TEXT.INSTALLED)
    setSecondaryButtonText(BUTTON_TEXT.REMOVE)
  }

  const toggleSuccess = () => {
    setButtonText(BUTTON_TEXT.SUCCESS)
    setTimeout(setActivated, 1000)
  }

  const setError = () => {
    setErrorMessage(ERROR.INSTALLING_TRACKING_ACTIVATION)
    setButtonText(BUTTON_TEXT.ERROR)
    setSecondaryButtonText(BUTTON_TEXT.TRY_AGAIN)
  }

  const toggleDeactivated = () => {
    setButtonText(BUTTON_TEXT.SUCCESS)
    setSecondaryButtonText(null)
    setTimeout(() => setButtonText(BUTTON_TEXT.INSTALL), 1000)
  }

  const updateClickInstallTag = async (install = true) => {
    setLoading(true)
    setErrorMessage(null)
    try {
      const res = await formService.updateInstallTag(
        install,
        settings.domainKey
      )
      console.log(res)
      settings.installTag = install
      if (install) toggleSuccess()
      else {
        toggleDeactivated()
      }
    } catch (error) {
      setError()
    }
    setLoading(false)
  }
  /**
   *
   * @param {string} domainKey
   */
  const setDomainKey = (domainKey) => {
    settings.domainKey = domainKey
    setSettings({ ...settings })
  }
  const paste = async () => {
    const text = await navigator.clipboard.readText()
    settings.domainKey = text
    setSettings({ ...settings })
  }

  useEffect(() => {
    setSettings(initSettings)
    if (initSettings?.installTag) setActivated()
    else {
      setButtonText(BUTTON_TEXT.INSTALL)
    }
    // eslint-disable-next-line
  }, [initSettings])

  const body = (
    <>
      <InfoBox></InfoBox>
      <div className="cheq-form-title">Domain Key</div>
      <div className="cheq-subtitle">
        <span>Domain key is required for both</span> <b>Paid Marketing</b> and{" "}
        <b>Bot Mitigation</b>
      </div>
      <div className={"cc-flex"}>
        <FormTextInput
          placeholder={"Domain Key"}
          value={settings.domainKey}
          setValueCB={(value) => {
            settings.domainKey = value
            setSettings({ ...settings })
          }}
          inputInner={<PasteElement onClick={() => paste()} />}
        />
        {!secondaryButtonText && (
          <Button
            onClick={() => updateClickInstallTag(true)}
            loading={loading}
            content={buttonText}
            errorMessage={errorMessage}
            className={"button-essential margin-left-16"}
            lower={true}
          />
        )}
        {secondaryButtonText && (
          <Button
            onClick={() =>
              secondaryButtonText === BUTTON_TEXT.REMOVE
                ? updateClickInstallTag(false)
                : updateClickInstallTag(true)
            }
            content={secondaryButtonText}
            className={
              "button-essential margin-left-16 button-remove-essential"
            }
          />
        )}
      </div>

      <BotzappingForm
        setDomainKey={setDomainKey}
        initSettings={initSettings}
      ></BotzappingForm>
    </>
  )

  const secondaryTitle = (
    <SecondaryTitle showCheckState={false} text={secondaryTitleText} />
  )

  return (
    <Section
      title="CHEQ Essentials Plugin"
      body={body}
      secondaryTitle={secondaryTitle}
    />
  )
}
export default InstallTag
